import { useQuery } from '@tanstack/react-query';
import { z } from 'zod';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { roleDtoSchema } from '../schemas/roleSchemas';
import { roleKeys } from './roleKeys';

export function useListRoles() {
  const tenantId = useTenantStore((s) => s.tenantId);

  return useQuery({
    queryKey: roleKeys.list(tenantId),
    queryFn: async ({ signal }) => {
      const raw = await apiClient.get(`api/v1/t/${tenantId}/roles`, { signal }).json();
      return z.array(roleDtoSchema).parse(raw);
    },
    enabled: !!tenantId,
    staleTime: 30_000,
  });
}
